import { FC, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { Tabs } from 'antd'
import { BusinessUnitTiny } from '../../types'
import { PerTabBarContent } from '../../components/custom_components/TabBarContent'
import { CompanySettingsPermissions } from './permissions'
import { CompanySettingsPermissionsInfo } from '../../shared/permissions/permission-helper'
import { CompanySettingsBuAppraisalTab } from './appraisal/AppraisalTab'
import Cascader, { CascaderOptionType } from 'antd/lib/cascader'
import './index.less'
import { searchOptionsFilter } from '../../components/custom_components/Cascader/util'
import { useCascaderSearchOnOpen } from '../../components/custom_components/Cascader/useCascaderSearchOnOpen'
import { CompanySettingsTabs } from './types'
import { CompanySettingsBuReviewerTab } from './reviewer/CompanySettingsBuReviewerTab'

const { TabPane } = Tabs

interface ICompanySettingsBuTabsProps {
  managedBusinessUnits: BusinessUnitTiny[]
  companySettingsPermissions: CompanySettingsPermissionsInfo
}

export const CompanySettingsBuTabs: FC<ICompanySettingsBuTabsProps> = ({ managedBusinessUnits, companySettingsPermissions }) => {
  const { t } = useTranslation()
  const [selectedBusinessUnit, setSelectedBusinessUnit] = useState<string>(managedBusinessUnits[0].id)
  const [activeTab, setActiveTab] = useState<string>(CompanySettingsTabs.appraisal)

  const companyOfBusinessUnit = !!managedBusinessUnits[0].company ? managedBusinessUnits[0].company.name : ''

  const cascaderOptions: CascaderOptionType[] = [
    {
      label: companyOfBusinessUnit,
      value: '1',
      children: managedBusinessUnits.map((businessUnit: BusinessUnitTiny) => ({ label: businessUnit.displayName, value: businessUnit.id })),
    },
  ]

  const onDropDownChanged = (val: string[]) => {
    setSelectedBusinessUnit(val[1])
  }

  const { cascaderRef, cascaderClassName, searchPlaceholder, onPopupVisibleChange } = useCascaderSearchOnOpen(
    t('companySettingsView.companyOrBusinessUnitCascaderSearchPlaceholder'),
  )

  return (
    <Tabs
      activeKey={activeTab}
      renderTabBar={() => (
        <PerTabBarContent
          tabs={
            <Tabs onChange={setActiveTab}>
              {companySettingsPermissions[CompanySettingsPermissions.appraisalsTab] && (
                <TabPane tab={t('companySettingsView.appraisalTab.heading')} key={CompanySettingsTabs.appraisal} />
              )}
              {companySettingsPermissions[CompanySettingsPermissions.reviewerTab] && (
                <TabPane tab={t('companySettingsView.reviewerTab.heading')} key={CompanySettingsTabs.reviewer} />
              )}
            </Tabs>
          }
          actions={
            <Cascader
              ref={cascaderRef}
              className={cascaderClassName}
              options={cascaderOptions}
              onChange={onDropDownChanged}
              placeholder={searchPlaceholder}
              allowClear={false}
              defaultValue={['1', managedBusinessUnits[0].id]}
              value={['1', selectedBusinessUnit]}
              style={{ width: '100%', marginLeft: '3.5px' }}
              disabled={managedBusinessUnits.length <= 1}
              showSearch={{ filter: searchOptionsFilter }}
              onPopupVisibleChange={onPopupVisibleChange}
            />
          }
        />
      )}
    >
      {companySettingsPermissions[CompanySettingsPermissions.appraisalsTab] && (
        <TabPane key={CompanySettingsTabs.appraisal}>
          <CompanySettingsBuAppraisalTab businessUnitId={selectedBusinessUnit} />
        </TabPane>
      )}
      {companySettingsPermissions[CompanySettingsPermissions.reviewerTab] && (
        <TabPane key={CompanySettingsTabs.reviewer}>
          <CompanySettingsBuReviewerTab
            businessUnitId={selectedBusinessUnit}
            buName={managedBusinessUnits.find((bu) => bu.id === selectedBusinessUnit)!.displayName}
            companyId={managedBusinessUnits.find((bu) => bu.id === selectedBusinessUnit)!.company!.id}
          />
        </TabPane>
      )}
    </Tabs>
  )
}
